import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { COOKIE_DISPLAY_MODE, useCookiePrompt } from '@ratehub/base-ui';
import { AccountApp } from '@ratehub/dashboards';
import { LayoutRow } from '@ratehub/web-components';
import { fetchProviderDetails } from '@ratehub/ins-common';

import withDynamicLocale from '../functions/withDynamicLocale';
import Layout from '../components/Layout';
import TemporaryGridOverride from '../definitions/TemporaryGridOverride';


const BANNER_CONTAINER_ID = 'banner-portal-target';

function AccountsPage({ content }) {
    useCookiePrompt({ display: COOKIE_DISPLAY_MODE.MODAL }); // users can't access account without cookies

    return (
        <Container
            hideBackgroundImage
            requiresLogin
            isGridDisabled
        >
            {/* Render target for React.Portal; for MessageBanner */}
            <div id={BANNER_CONTAINER_ID} />

            <LayoutRow className="rh-overflow-visible">
                <AccountApp
                    className="rh-flex-grow-1"
                    insuranceProviders={{
                        insurers: content.insurers,
                        brokers: content.brokers,
                    }}
                    portalBannerId={BANNER_CONTAINER_ID}
                />
            </LayoutRow>
        </Container>
    );
}

AccountsPage.getInitialProps = async function({ locale }) {
    const { insurers, brokers } = await fetchProviderDetails();
    // In future ticket, we would fetch insurers and brokers here
    return {
        locale: locale,
        content: {
            insurers,
            brokers,
        },
        headerSettings: {
            enableDropShadow: true,
            disableMenu: true,
        },
        footerSettings: {
            isDisabled: true,
            isPopularContentDisabled: true,
        },
    };
};

AccountsPage.propTypes = {
    content:    PropTypes.any.isRequired,
};

const Container = styled(Layout)`
    ${TemporaryGridOverride}
`;

export default withDynamicLocale(observer(AccountsPage));
